/**
 * # Payment Inputs
 * Input containers for payment details.
 *
 * @module components/payments.js
 */

import CardNumber from './payments/card-number';
import CardExpiration from './payments/card-expiration';
import CardSecurityCode from './payments/card-security-code';
import UnifiedCreditCard from './payments/unified-credit-card';
import CardSet from './payments/card-set';
import CurrencyInput from './payments/currency-input';

const Payments = {
  CardNumber,
  CardExpiration,
  CardSecurityCode,
  UnifiedCreditCard,
  CardSet,
  CurrencyInput
};

export default Payments;
